import React, { useEffect } from "react";
import PageTitle from "../../components/shared/PageTitle";
import "../../registration.css";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export default function Index() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const lang = i18n.language.toUpperCase();
  const locale = useSelector((state) => state.locale.locale);
  const jwtToken = localStorage.getItem("jwt-token");

  useEffect(() => {
    if (!jwtToken) {
      navigate("/login");
    }
  }, []);

  useEffect(() => {
    const addScriptOnce = (src) => {
      const alreadyAdded = Array.from(document.scripts).some(
        (existingScript) => existingScript.src === src
      );
      if (alreadyAdded) return;

      const script = document.createElement("script");
      script.src = src;
      script.async = true;
      document.body.appendChild(script);
    };

    addScriptOnce("https://code.jquery.com/jquery-3.2.1.min.js");
    addScriptOnce("https://www.steelytoe.com/static/steelyreg.latest.min.js");

    if (!document.head.querySelector('meta[name="robots"]')) {
      const meta = document.createElement("meta");
      meta.name = "robots";
      meta.content = "NOINDEX, NOFOLLOW";
      document.head.appendChild(meta);
    }
  }, []);

  return (
    <div className="md:px-0 px-4">
      <div className="relative">
        <PageTitle title={locale === "en" ? "Registration" : "Registrasi"} />
      </div>
      {/* <div className="relative top-80 bg-black 2xl:px-0 md:px-14 px-0 pb-96">
                <div className="bg-black min-h-screen h-full container mx-auto w-full font-soulmaze">
                    <h1 className="text-white text-2xl">{t("registration.body")}</h1>
                </div>
            </div> */}
      <div className="relative top-80 bg-black 2xl:px-0 md:px-14 px-0 pb-96">
        <div className="bg-black min-h-screen h-full container mx-auto w-full font-ttFirsNeue">
          <link
            rel="stylesheet"
            media="all"
            href="https://www.steelytoe.com/static/steelyreg.latest.css"
          />
          <div
            id="steelytoeRegContainer"
            event-id="564"
            lang={lang}
            className=""
          >
            <h3>Loading Registration Page, please standby ...</h3>
          </div>
        </div>
      </div>
    </div>
  );
}
